<template>
  <div class="global-modal" v-if="isVisible" @click.self="close">
    <div class="modal-content">
      <input
        type="number"
        ref="modalInput"
        v-model.number="inputValue"
        placeholder="请输入数量"
        min="0"
        @keyup.enter="confirm"
      >
      <div class="actions">
        <button @click="close">取消</button>
        <button @click="confirm">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Number,
    food: Object
  },
  
  data() {
    return {
      inputValue: this.value,
	  isVisible: true ,
      isClosed: false // 添加关闭状态标志
    }
  },
  
  mounted() {
    this.$refs.modalInput.focus()
    this.$refs.modalInput.select();
  } ,
  methods: {
    close() {
      if (this.isClosed) return;
	   this.isVisible = false;  // 隐藏弹窗
      this.isClosed = true;
      this.$emit('close');
    },
    confirm() {
	//console.log(this.inputValue);
      this.$emit('input', this.inputValue);
      this.close();
    }
  }
}
</script>

<style scoped>
.global-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2147483647; /* 最高层级 */
    transition: opacity 0.3s ease;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 80%;
  max-width: 400px;
    transition: transform 0.3s ease;
}
 
.modal-content input {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 15px;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}

.actions button {
  padding: 8px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.actions button:first-child {
  background: #f0f0f0;
}

.actions button:last-child {
  background: rgba(0, 160, 220);
  color: white;
}
</style>